<div id="PJRadarChartDiv"></div>

<div class="pj-bar-du-bar-chart" *ngIf="barLoader && PJRadarData.length==0">Loading...</div>
<div class="pj-bar-du-bar-chart" *ngIf="!barLoader && PJRadarData.length==0">No data for this patient</div>